export const environment = {
  production: true,
  apiPath: 'https://admins.talentlitmus.com',
  apiPathV2:'https://api.adminv2.talentlitmus.com',
  apiKeyV2:'MYLcvDAg5175KH5vTvGtvanxLtFNr8yU',
  env: 'production',
};
